import { BaseField } from './BaseField';

const imgParkingIcon = "/assets/parking-icon.svg";

export class ParkingField extends BaseField {
  constructor() {
    super({
      key: 'parking',
      icon: imgParkingIcon,
      defaultLabel: 'Miej. parkingowe'
    });
  }

  renderForList(property) {
    const parking = property.parkingSpots || 0;
    const garage = property.garageSpots || 0;
    const total = parking + garage;

    if (total === 0) {
      return { label: 'Postojowe', value: 'brak' };
    }

    return { label: 'Postojowe', value: `${total}` };
  }

  renderForCard(property) {
    const parking = property.parkingSpots || 0;
    const garage = property.garageSpots || 0;

    if (parking === 0 && garage === 0) {
      return { label: 'Miej. parkingowe', value: 'brak' };
    }

    const parts = [];
    if (parking > 0) parts.push(`${parking} postojowe`);
    if (garage > 0) parts.push(`${garage} garażowe`);

    return {
      label: 'Miej. parkingowe',
      value: parts.join(', ')
    };
  }
}
